import React from 'react';
import PropTypes from 'prop-types';

import { DefaultPopup, Label } from '@atlas/ui';

import { FirstStep } from 'common/Popup/AddToHomeScreenIOSPopup/Steps/FirstStep';
import { SecondStep } from 'common/Popup/AddToHomeScreenIOSPopup/Steps/SecondStep';
import { ThirdStep } from 'common/Popup/AddToHomeScreenIOSPopup/Steps/ThirdStep';

export const AddToHomeScreenIOSPopup = ({ onClose, visible }) => {
  if (!visible) return null;

  return (
    <DefaultPopup className="add-to-home-screen-ios-popup" onClose={onClose}>
      <div className="add-to-home-screen-ios-popup__header">
        <Label
          className="add-to-home-screen-ios-popup__title title-bold-text"
          message="add_to_home_screen_popup_title"
        />
        <Label
          className="add-to-home-screen-ios-popup__description sub-title-400-text"
          message="add_to_home_screen_popup_description"
        />
      </div>

      <div className="add-to-home-screen-ios-popup__steps">
        <FirstStep />
        <SecondStep />
        <ThirdStep />
      </div>
    </DefaultPopup>
  );
};

AddToHomeScreenIOSPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};
